/**
 * Platform takedown switch (F6) — the tenant-scoped admin surface, separate
 * from the authenticated org/trainer editing API (`publicPage.api.ts`).
 */
import type {
  ApiPublicPageAdminListResponse,
  FetchPublicPageAdminListArgs,
  ApiPublicPageAdminRow,
  BlockPublicPageArgs,
} from './types/publicPageAdmin.types';

import { get, patch } from './axios';

const ADMIN_PUBLIC_PAGES_PATH = '/v2/admin/public-pages';

// Fix round 1, Finding 5: 1-based `offset`/capped `limit` — the BE no
// longer returns every row unbounded.
export const fetchPublicPageAdminList = async ({
  offset,
  limit,
}: FetchPublicPageAdminListArgs) => {
  const response = await get<ApiPublicPageAdminListResponse>(
    ADMIN_PUBLIC_PAGES_PATH,
    { query: { limit: String(limit), offset: String(offset) } },
  );
  return response ?? { data: [], limit, offset, total: 0 };
};

export const blockPublicPage = async ({
  pageId,
  isBlocked,
}: BlockPublicPageArgs) => {
  const response = await patch<ApiPublicPageAdminRow>(
    `${ADMIN_PUBLIC_PAGES_PATH}/${pageId}/block`,
    { isBlocked },
  );
  return response?.data ?? null;
};
